export default "/8522fe2631ecefb1e3967be9883671f05392a386/14ed8dc335eec8ccd043173219a4387f.svg";